import { createI18n } from '../../functions';

import errorText from './errorText';

const i18n = createI18n({
	error: errorText,
});

export default i18n;